<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <el-row v-if="changed" :gutter="10" style="margin-top: 8px">
      <el-col
        :xs="24"
        :sm="24"
        :md="24"
        :lg="16"
        :xl="16"
        style="margin-bottom: 15px"
      >
        <el-table
          size="mini"
          height="305px"
          :data="notesData"
          style="width: 100%; margin-bottom: 20px; border-radius: 5px"
        >
          <el-table-column label="Denomination" prop="note"> </el-table-column>
          <el-table-column label="Opening Notes Count" prop="openCount">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                @change="updateOpenAmount(scope.$index, scope.row)"
                :precision="0"
                :min="0"
                v-model="scope.row.openCount"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            v-if="$route.query.update"
            label="Closing Notes Count"
            prop="closeCount"
            width="150"
          >
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                @change="updateCloseAmount(scope.$index, scope.row)"
                :precision="0"
                :min="0"
                v-model="scope.row.closeCount"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <h6 class="mx-auto">Cash Additions & Subtractionss</h6>
        <CFAddDeductTable
          :cashData="cashData"
          :updateCashData="updateCashData"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <el-card
          class="box-card"
          style="background-color: rgb(56 98 203); color: #fff"
        >
          <div class="clearfix text item" v-if="$route.query.update">
            <span>Cash Sales</span>
            <span style="float: right; padding: 3px 0"
              >{{ sales.toLocaleString() }} LKR</span
            >
          </div>
          <div class="clearfix text item">
            <span>Cash Open Amount</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updateSummary()"
                :precision="0"
                :min="0"
                v-model="open"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="$route.query.update">
            <span>Cash Total Addition</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                disabled
                @change="updateSummary()"
                size="mini"
                :precision="2"
                :min="0"
                v-model="add"
              ></el-input-number>
            </span>
          </div>

          <!-- <div class="clearfix">
          <span style="color: #000; margin-bottom: 5px">Payment Details</span>
        </div> -->
          <div class="clearfix text item" v-if="$route.query.update">
            <span>Cash Total Subtraction</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                disabled
                size="mini"
                @change="updateSummary()"
                :precision="2"
                :min="0"
                v-model="deduct"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="$route.query.update">
            <span>Cash should be in the register</span>
            <span style="float: right; padding: 3px 0"
              >{{ inRegi.toLocaleString() }} LKR</span
            >
          </div>
          <div class="clearfix text item" v-if="$route.query.update">
            <span>Cash Flow Closing Amount</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updateSummary()"
                :precision="2"
                :min="0"
                v-model="close"
              ></el-input-number>
            </span>
          </div>

          <div class="clearfix text item" v-if="$route.query.update">
            <span>Difference</span>
            <span style="float: right; padding: 3px 0"
              >{{ diff.toLocaleString() }} LKR</span
            >
          </div>
          <div class="clearfix text item">
            <span>Notes</span>
            <div style="padding: 3px 0">
              <el-input :rows="8" type="textarea" v-model="desc"></el-input>
            </div>
          </div>
          <div class="clearfix">
            <el-button
              round
              @click="saveCashFlow"
              style="float: right; background-color: #ff6014; margin-top: 10px"
              size="medium"
              type="warning"
              >SAVE</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import CFAddDeductTable from "./CFAddDeductTable.vue";
export default {
  name: "createinvoice",
  components: {
    CFAddDeductTable,
  },
  data() {
    return {
      open: 0,
      close: 0,
      end: "",
      add: 0,
      deduct: 0,
      inRegi: 0,
      diff: 0,
      sales: 0,
      cashData: [],
      desc: "",
      loading: false,
      loading1: false,
      changed: true, // otherwise create page will be blank
      notesData: [
        { note: "5000", openCount: 0, closeCount: 0 },
        // { note: "2000", openCount: 0, closeCount: 0 },
        { note: "1000", openCount: 0, closeCount: 0 },
        { note: "500", openCount: 0, closeCount: 0 },
        { note: "100", openCount: 0, closeCount: 0 },
        { note: "50", openCount: 0, closeCount: 0 },
        { note: "20", openCount: 0, closeCount: 0 },
        { note: "10", openCount: 0, closeCount: 0 },
        { note: "5", openCount: 0, closeCount: 0 },
        { note: "2", openCount: 0, closeCount: 0 },
        { note: "1", openCount: 0, closeCount: 0 },
      ],
    };
  },
  destroyed() {
    // Remove listener when component is destroyed
    // this.$barcodeScanner.destroy();
  },
  methods: {
    updateCashData() {
      console.log("this.cashData", this.cashData);
      this.add = 0;
      this.deduct = 0;
      for (const row of this.cashData) {
        if (row.type === "add") this.add += row.amount;
        if (row.type === "deduct") this.deduct += row.amount;
        this.updateSummary();
      }
    },
    updateOpenAmount(index, row) {
      this.open = 0;
      this.notesData.forEach((data) => {
        this.open += +data.note * data.openCount;
      });
      this.updateSummary();
    },
    updateCloseAmount(index, row) {
      this.close = 0;
      this.notesData.forEach((data) => {
        this.close += +data.note * data.closeCount;
      });
      this.updateSummary();
    },
    updateSummary() {
      this.inRegi = this.open + this.sales + this.add - this.deduct;
      this.diff = this.close - this.inRegi;
    },
    saveCashFlow() {
      this.loading1 = true;
      this.changed = false;
      if (this.$route.query.create) {
        this.$store.state.secondaryDatabase
          .collection("cashflow")
          .add({
            notes: this.notesData,
            open: this.open,
            store: this.$store.state.selectedStore,
            start: firebase.firestore.Timestamp.now(),
            close: this.close,
            sales: this.sales,
            add: this.add,
            deduct: this.deduct,
            inRegi: this.inRegi,
            diff: 0, // this.diff - only setting value when closing cashflow,
            desc: this.desc,
            cashData: this.cashData,
            isCurrent: true,
            updated: firebase.firestore.Timestamp.now(),
            createdBy: this.$store.state.systemUser.name,
          })
          .then((doc) => {
            this.$notify({
              title: "Success",
              message: "Cash Flow created",
              type: "success",
            });
            this.loading1 = false;
            this.changed = true;
          })
          .catch((error) => alert(error));
      }
      if (this.$route.query.update) {
        this.cashData.forEach((item) => (item.date = new Date(item.date)));
        this.$store.state.secondaryDatabase
          .collection("cashflow")
          .doc(this.$route.query.id)
          .update({
            notes: this.notesData,
            open: this.open,
            end: this.end
              ? this.end
              : this.close || this.inRegi === 0 // this.inRegi === 0 means all balance to 0
              ? firebase.firestore.Timestamp.now()
              : "",
            updated: firebase.firestore.Timestamp.now(),
            close: this.close,
            sales: this.sales,
            add: this.add,
            deduct: this.deduct,
            inRegi: this.inRegi,
            diff: this.close || this.inRegi === 0 ? this.diff : 0, // this.diff - only setting value when closing cashflow
            desc: this.desc, 
            cashData: this.cashData,
            isCurrent: this.end ? false : this.close || this.inRegi === 0 ? false : true,
            updated: firebase.firestore.Timestamp.now(),
            updatedBy: this.$store.state.systemUser.name,
          })
          .then((doc) => {
            // this.$store.state.secondaryDatabase
            //   .collection("shops")
            //   .doc(this.shops[0].id)
            //   .update({
            //     curSales: 0,
            //   })
            //   .then((doc) => {

            //   });
            this.$notify({
              title: "Success",
              message: "Cash Flow updated",
              type: "success",
            });
            this.loading1 = false;
            this.changed = true;
          })
          .catch((error) => alert(error));
      }
    },
  },
  created() {
    if (this.$route.query.update) {
      this.loading = true;
      this.changed = false;
      this.$store.state.secondaryDatabase
        .collection("cashflow")
        .doc(this.$route.query.id)
        .get()
        .then((doc) => {
          this.open = doc.data().open;
          this.close = doc.data().close;
          this.end = doc.data().end;
          this.add = doc.data().add;
          this.deduct = doc.data().deduct;
          this.inRegi = doc.data().inRegi;
          this.diff = doc.data().diff;
          this.sales = doc.data().sales;
          this.cashData = doc.data().cashData;
          this.desc = doc.data().desc;
          this.notesData = doc.data().notes || this.notesData;
          this.cashData.forEach(
            (item) => (item.date = item.date.toDate().toLocaleString())
          );
          this.updateSummary();
          this.loading = false;
          this.changed = true;
        })
        .catch((error) => alert(error));
    }
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>


// WEBPACK FOOTER //
// src/components/admin/CashFlow.vue